import { Trans } from '@lingui/react/macro';
import { type PropsWithChildren, type ReactNode } from 'react';

import Warning from '@/assets/svg/warning.svg?react';
import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  message?: ReactNode;
  detail?: ReactNode;
};

const WidgetError = ({ className = '', message, detail, children }: PropsWithChildren<Props>) => {
  const resolvedMessage = message ?? <Trans>Sorry, something went wrong</Trans>;
  return (
    <div className={cn('m-auto flex flex-col items-center p-8 text-center', className)}>
      <div className={cn('flex w-full flex-col flex-wrap items-center gap-6')}>
        <Warning className="size-15 shrink-0" />
        <div className="flex flex-col gap-2">
          <Text variant="headline" weight="light">
            {resolvedMessage ? resolvedMessage : <Trans>An unknown error occurred.</Trans>}
          </Text>
          {detail != null && (
            <Text className="max-w-175" variant="body2" weight="light">
              {detail}
            </Text>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default WidgetError;
